import styled from 'styled-components';

import {
  useHistory,
} from 'react-router-dom';

import LogoImage from '../assets/logo.webp';
import Container from '@mui/material/Container';

const BgBox = styled.div`
  min-height: 100vh;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  overflow: hidden;
`

function Home({ participantInfo, participantHash }: { participantInfo?: Record<string, any>, participantHash?: string }) {
  const history = useHistory();

  setTimeout(() => {
    if (!!participantInfo) {
      history.push(`/my?hash=${encodeURIComponent(participantHash || '')}`);
    }
  }, 750);

  return (
    <BgBox>
      <Container maxWidth="xs">
        <img src={LogoImage} alt="logo" style={{ width: '100%', height: 'auto', display: 'block' }} />
      </Container>
    </BgBox>
  )
}

export default Home;
